/* eslint-disable security/detect-object-injection */
import React from 'react';
import PropTypes from 'prop-types';
import toCapitalCase from 'to-capital-case';
import { BASE_URL, CATEGORIES } from '../constants';
import './Filter.css';

const Filter = props => {
  const handleChange = e => {
    props.updateFilter(toCapitalCase(e.target.name));
  };
  return (
    <div
      className='filter-wrapper'
      style={{
        background: `url(${BASE_URL}/images/checkboxes-fondo.png) 50% no-repeat`,
      }}
    >
      <ul className='filter-categories'>
        <>
          {CATEGORIES.map((category, index) => {
            const checked = props[category];
            const classNames = `filter-category ${category}`;
            const id = `filter-${category}`;
            const key = `filter-${index + 1}`;

            return (
              <li key={key} className={classNames}>
                <input
                  checked={checked}
                  id={id}
                  name={category}
                  onChange={handleChange}
                  type='checkbox'
                />
                <label htmlFor={id}>
                  <span>{category.toUpperCase()}</span>
                </label>
              </li>
            );
          })}
        </>
      </ul>
    </div>
  );
};

Filter.defaultProps = {
  updateFilter: null,
};

Filter.propTypes = {
  updateFilter: PropTypes.func,
};

export default Filter;
